import { getEnv } from '@atlassian/pillar/runtime/env';

const config = {
	featureGateApiKey: 'bbd011eb-3e73-42d4-8212-724f450bbb29',
};

const environmentOverrides: Partial<Record<ReturnType<typeof getEnv>, typeof config>> = {
	staging: {
		featureGateApiKey: 'bbd011eb-3e73-42d4-8212-724f450bbb29',
	},
	production: {
		featureGateApiKey: 'f8f89beb-985a-4fd3-8f5c-1768050e61d8',
	},
};

export const getFeatureFlagConfig = (): {
	env: 'production' | 'staging' | 'development' | 'local';
	featureGateApiKey: string;
} => {
	const env = getEnv();

	return {
		env,
		...config,
		...environmentOverrides[env],
	};
};
